var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-page',[_c('b-card',[_vm._v("\n        Please wait redirecting to home page...\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }